import { DeployInfo, GetDeployInfoRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const DEFAULT_DEPLOY_INFO: DeployInfo = { branchName: 'unknown', deployTime: new Date().toISOString() }

class DeployInfoApi extends ApiBase {
    async getServerDeployInfo() {
        const response = await this._getRequest<GetDeployInfoRequest>('/deployinfo')
        return response
    }

    async getClientDeployInfo() {
        try {
            const response = await fetch('/deployinfo.json')
            if (response.ok) {
                const data = await response.json()
                return data as DeployInfo
            } else {
                console.warn('Failed to fetch deployinfo.json (using defaults):', response.status)
            }
        } catch (error) {
            console.error('Error loading deployinfo.json:', error)
        }

        return DEFAULT_DEPLOY_INFO
    }
}

export default DeployInfoApi
